import { SET_TERMSANDCONDITION_POLICY_CONTENT } from "actions/types";

let initialState = {
  termsAndConditionPolicyContent: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_TERMSANDCONDITION_POLICY_CONTENT: {
      return {
        ...state,
        termsAndConditionPolicyContent: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
